// extracted by mini-css-extract-plugin
export default {"formHeading":"qI-z","form":"rI-z","submitBtn":"sI-z","disabled":"tI-z","input":"uI-z","error":"vI-z","submitMsg":"wI-z","signIn":"xI-z"};